export const filterNormalize = (params, enablePagination = false, selectedPageSize, selectedCurrentPage) => {
  const {
    reportFilterRegional,
    reportFilterDistrict = [],
    periods = [],
    period = null,
    reportFilterJourney,
    reportFilterCustomer = [],
    reportFilterActionType = [],
    reportFilterType,
    reportFilterMember,
    reportFilterStatus,
    organization,
    importType,
    pageSize = selectedPageSize, // só usado se enablePagination for true
    currentPage = selectedCurrentPage // só usado se enablePagination for true
  } = params

  const normalizedData = {
    regionIds: reportFilterRegional,
    districtIds: reportFilterDistrict,
    periods,
    period,
    actionTemplateId: reportFilterJourney,
    customerIds: reportFilterCustomer,
    actionTypeIds: reportFilterActionType,
    membersIds: reportFilterMember,
    reportType: reportFilterType,
    status: reportFilterStatus,
    organizationId: organization,
    importType: importType,
    otherFilters: params.otherFilters
  }

  // Adiciona dados de paginação apenas se enablePagination for true
  if (enablePagination) {
    normalizedData.pageSize = pageSize
    normalizedData.currentPage = currentPage
  }

  return normalizedData
}
